import React, { Component } from 'react'
import { MDBView, MDBMask, MDBIcon } from 'mdbreact'
import { Link } from 'react-router-dom'

import Vault from '../addVault/Vault'
import Spinner from '../../../components/spinner/Spinner'

import { connect } from 'react-redux'

export class MainVault extends Component {

    state = {
        modal: false
    }

    toggle = () => {
        this.setState({
            modal: !this.state.modal
        });
    }
    render() {
        const { vaults, loading } = this.props.vault
        return (
            <div className="container-fluid mt-5">
                <Vault modal={this.state.modal} toggle={this.toggle} />
                <h1>
                    Your Vault
        </h1>
                <hr />
                <div className="row">
                    {loading
                        ? <Spinner margin='100px auto' size={50} />
                        : vaults
                            ? vaults.map((val, index) => {
                                return <div key={index} className="col-md-3 mt-2">
                                    <Link to={`/main/${val}`}>
                                        <MDBView waves>
                                            <img
                                                src="https://mdbootstrap.com/img/Others/documentation/forest-sm-mini.jpg"
                                                className="img-fluid"
                                                alt=""
                                            />
                                            <MDBMask style={{ cursor: 'pointer' }} className="flex-center" overlay="teal-strong">
                                                <h2 className="white-text">{val}</h2>
                                            </MDBMask>
                                        </MDBView>
                                    </Link>
                                </div>
                            })
                            : null
                    }
                    {loading
                        ? null
                        : vaults
                            ? <div className="col-md-3 mt-2" >
                                <MDBView onClick={this.toggle} waves>
                                    <img
                                        src="https://mdbootstrap.com/img/Others/documentation/forest-sm-mini.jpg"
                                        className="img-fluid"
                                        alt=""
                                    />
                                    <MDBMask style={{ cursor: 'pointer' }} className="flex-center" overlay="teal-strong">
                                        <MDBIcon icon="plus" style={{ fontSize: '100px', color: 'white' }} />
                                    </MDBMask>
                                </MDBView>
                            </div>
                            : null}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return (
        {
            vault: state.userData
        }
    )
}


export default connect(mapStateToProps)(MainVault)